import { useRootSelector } from '@/hooks/selector.hook';
import { GoArrowLeft } from 'react-icons/go';
import { SidebarMenu } from '@/components/ui/sidebar';
import { CustomIcon } from '@/components/CustomIcon';
import { Link } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';

type SettingSidebar = {
  setCurrentView: (view: 'MAIN' | 'SETTINGS') => void;
  isCollapsed: boolean;
  isActive: (pageTitle: string | null | undefined) => boolean;
};

const SettingSidebar = ({ setCurrentView, isCollapsed, isActive }: SettingSidebar) => {
  const dataMenuSetting = useRootSelector((state) => state.permission.sections);
  const isLoading = useRootSelector((state) => state.loading.box['menu-setting']);

  return (
    <div className="mt-[3rem]">
      <div
        className={`${isCollapsed ? 'block lg:pl-[1rem]' : 'flex items-center gap-[1rem] lg:pl-[2.5rem]'} mb-[2rem] pl-[1rem]`}
      >
        <GoArrowLeft
          className="text-[#57E8BA] cursor-pointer size-[3rem]"
          onClick={() => setCurrentView('MAIN')}
        />
        {!isCollapsed && <p className="text-[#57E8BA] text-[2.4rem] font-medium">Settings</p>}
      </div>

      <SidebarMenu className="flex flex-col gap-[2rem] mt-[2rem]">
        {isLoading
          ? // Skeleton loading state
          Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="flex flex-col gap-[1rem] mb-[1.5rem]">
              {!isCollapsed && (
                <div className="flex items-center gap-[1rem] pl-[1rem]">
                  <Skeleton className="w-[1.6rem] h-[1.6rem] rounded-full dark:bg-[#3A3A3A] bg-[#E0E0E0]" />
                  <Skeleton className="w-[8rem] h-[1.6rem] dark:bg-[#3A3A3A] bg-[#E0E0E0]" />
                </div>
              )}
              <div className="flex flex-col gap-[0.8rem] pl-[1rem] lg:pl-[2.5rem]">
                <Skeleton className="w-full h-[3.4rem] rounded-[0.8rem] dark:bg-[#3A3A3A] bg-[#E0E0E0]" />
                <Skeleton className="w-[80%] h-[3.4rem] rounded-[0.8rem] dark:bg-[#3A3A3A] bg-[#E0E0E0]" />
              </div>
            </div>
          ))
          : // Actual data rendering
          dataMenuSetting?.map((section, idx) => (
            <div key={idx} className="flex flex-col">
              {!isCollapsed && (
                <div className="flex items-center gap-[0.4rem] dark:text-[#7A7A7A] text-[#121212] mb-[1rem] pl-[1rem]">
                  {/* Tuỳ vào icon của section nếu có */}
                  <CustomIcon type={section.icon} className="w-[2.4rem] h-[2.4rem]" />
                  <span className="text-[1.4rem] font-semibold">{section.label}</span>
                </div>
              )}

              {/* Map các item con bên trong danh mục đó (Users, Company Profile...) */}
              <div className="flex flex-col gap-[0.8rem] pl-[1rem] lg:pl-[2.5rem]">
                {section.items?.map((child: any, cIdx: number) => (
                  <Link
                    to={child.route || '#'}
                    key={cIdx}
                    className={`p-[1rem] rounded-[0.8rem] text-[1.4rem] transition-all
                   ${isActive(child.label) ? 'dark:bg-[#2A3A35] dark:text-[#57E8BA] bg-[#FFFFFF]' : 'dark:text-white text-[#121212] hover:text-[#57E8BA]'}
                 `}
                  >
                    {child.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
      </SidebarMenu>
    </div>
  );
};

export default SettingSidebar;
